import get from 'lodash.get';
import status from 'src/js/modules/status';
import statusNames from '../constants/status-names';

const getSubscriptionsStatus = (rootState) =>
  get(status.selectors.getStatus(rootState), statusNames.SUBSCRIPTIONS);

export default getSubscriptionsStatus;
